const ENVIRONMENTS = {
  production: {
    BASE_URL: "https://corvellwarranty.acrossassist.com",
    API_BASE_URL: "https://corvellwarranty.acrossassist.com",
  },
  staging: {
    BASE_URL: "https://test2.acrossassist.in",
    API_BASE_URL: "https://test2.acrossassist.in",
  },
  development: {
    BASE_URL: "http://localhost:3000",
    API_BASE_URL: "https://test2.acrossassist.in",
  },
};

const getEnvironment = () => {
  const baseUrl = window.location.origin;
  if (baseUrl === ENVIRONMENTS.production.BASE_URL) {
    return "production";
  } else if (baseUrl === ENVIRONMENTS.staging.BASE_URL) {
    return "staging";
  } else if (baseUrl === ENVIRONMENTS.development.BASE_URL) {
    return "development";
  } else {
    // Default to development if not matched
    return "development";
  }
};

const CURRENT_ENV = getEnvironment();

export const URL_CONFIG = {
  ...ENVIRONMENTS[CURRENT_ENV],
};
